import { render, staticRenderFns } from "./VueInlineAlert.vue?vue&type=template&id=904a71fa&scoped=true&"
import script from "./VueInlineAlert.vue?vue&type=script&lang=js&"
export * from "./VueInlineAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904a71fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
